'use strict';
const angular = require('angular');

export class mailComposerSendComponent {
  /*@ngInject*/
  constructor(RecipientListService, MailsService, Config, IntegrationService) {

    this.RecipientListService = RecipientListService;
    this.IntegrationService = IntegrationService;
    this.MailsService = MailsService;
    this.MailBlastConfig = Config.getModuleConfig(Config.Modules.MailBlast);

    this.blacklist = this.MailBlastConfig.getBlacklist().map(email => email.toLowerCase());

    this.RecipientListService.query((data) => {

      /* Custom Recipient Lists */
      this.recipientLists = data.map(list => {
        list.custom = true;
        return list;
      });

      /* System Recipient Lists: By Role */
      let systemRecipientLists = this.MailBlastConfig.getSystemRecipientLists();

      systemRecipientLists.forEach(systemList => {

        RecipientListService.getSystemList({
          role: systemList.role,
          newsletter: systemList.newsletter || 'false'
        }, recipients => {
          this.recipientLists = this.recipientLists.concat({
            _id: "" + Math.floor(Math.random() * Math.floor(1024)) + (new Date().getTime()),
            system: true,
            name: systemList.name,
            description: systemList.description || '',
            recipients: recipients
          });
        });
      }, err => {
        console.log("Could not retrieve recipient lists from server.")
      });

      /* System Recipient Lists: By Association */
      let systemRecipientListsAssociation = this.MailBlastConfig.getSystemRecipientListsAssociation();

      systemRecipientListsAssociation.forEach(systemList => {

        RecipientListService.getSystemListByAssociation({
          association: systemList.association,
          newsletter: systemList.newsletter || 'false'
        }, recipients => {
          this.recipientLists = this.recipientLists.concat({
            _id: "" + Math.floor(Math.random() * Math.floor(1024)) + (new Date().getTime()),
            association: true,
            name: systemList.name,
            description: systemList.description || '',
            recipients: recipients
          });
        });
      }, err => {
        console.log("Could not retrieve recipient lists from server.")
      });
    });

    /* Suite Recipient Lists */
    let suiteRecipientListsAssociation = this.MailBlastConfig.getSuiteRecipientLists();

    suiteRecipientListsAssociation.forEach(suiteList => {

      this.IntegrationService.querySuiteLDAP({
        base: btoa("cn=" + suiteList.communityCode + ", ou=recipientLists, o=conduu"),
        filter: btoa("(objectClass=owner)")
      }, data => {

        if (data && data[0] && data[0].json) {
          this.recipientLists = this.recipientLists.concat({
            _id: "" + Math.floor(Math.random() * Math.floor(1024)) + (new Date().getTime()),
            suite: true,
            name: suiteList.name,
            description: suiteList.description || '',
            recipients: JSON.parse(data[0].json)
          });
        }

      }, err => {
        console.log("Could not retrieve suite recipient lists from server.")
      });
      });

  }

  $onInit = function () {
    this.config = this.resolve.config;
  };

  ok(recipientListId) {
    let mail = this.config.mail;

    mail.recipients = this.getRecipients(recipientListId);

    this.MailsService.send({id: mail._id}, mail, (res) => {
      this.close({$value: {mailId: mail._id, archiveCategory: this.category}});
    }, (err) => {
      console.log("Could not send mail");
    });
  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }

  getDescription(id) {
    let idx = this.recipientLists.findIndex(o => o._id == id);
    return this.recipientLists[idx].description;
  }

  getRecipients(ids) {
    let recipients = [];
    let cleanedRecipients = [];

    ids.forEach(id => {
      let idx = this.recipientLists.findIndex(o => o._id == id);
      recipients = recipients.concat(this.recipientLists[idx].recipients);
    });

    // Remove emails on blacklist
    cleanedRecipients = recipients.filter(email => !this.blacklist.includes(email.toLowerCase()));

    /* remove duplicates:
     * https://stackoverflow.com/questions/1960473/get-all-unique-values-in-a-javascript-array-remove-duplicates */
    return [...new Set(cleanedRecipients)];
  }

}

export default angular.module('conduApp.mailComposerSendComponent', [])
  .component('mailComposerSendComponent', {
    template: require('./mail-composer-send.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: mailComposerSendComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/mail-composer/send/mail-composer-send.component.js